import React from "react";
import { useTranslation } from "react-i18next";
import { Button, Icon, Modal, Popconfirm } from "@xala/common-ui";

interface IFormModalModalProps {
  isLoading: boolean;
  isVisible: boolean;
  isNewForm: boolean;
  isDisabled?: boolean;
  isDeleteButtonEnabled: boolean;
  createFormTitle: string;
  editFormTitle?: string;
  modalClassName: string;
  submitFormName: string;
  onCloseModal: () => void;
  onDeleteButtonClick?: () => void;
  width?: number;
}

export const FormModal: React.FC<IFormModalModalProps> = (props) => {
  const {
    isVisible,
    isNewForm,
    isLoading,
    isDisabled,
    isDeleteButtonEnabled,
    createFormTitle,
    editFormTitle,
    submitFormName,
    modalClassName,
    onDeleteButtonClick,
    onCloseModal,
    children,
    width,
  } = props;

  const { t } = useTranslation();
  const title = isNewForm ? createFormTitle : editFormTitle;

  const renderFooter = () => {
    return (
      <>
        {renderDeleteButton()}
        <Button key="cancel" onClick={onCloseModal} type="link">
          {t("Cancel", "Cancel")}
        </Button>
        <Button
          form={submitFormName}
          key="submit"
          htmlType="submit"
          type="primary"
          loading={isLoading}
          disabled={isDisabled}
        >
          {t("Save", "Save")}
        </Button>
      </>
    );
  };

  const renderDeleteButton = () => {
    if (isDeleteButtonEnabled && !isNewForm) {
      return (
        <Popconfirm
          key="popconfirm"
          title={t(
            "ConfirmDelete",
            "Are you sure you want to delete this item?"
          )}
          onConfirm={onDeleteButtonClick}
          onCancel={() => {}}
          okText={t("Yes", "Yes")}
          cancelText={t("No", "No")}
        >
          <Button
            disabled={isLoading || isDisabled}
            key="delete"
            shape="circle"
            danger={true}
            icon={<Icon type="delete" />}
            style={{ float: "left" }}
          ></Button>
        </Popconfirm>
      );
    }
  };

  return (
    <div className={modalClassName}>
      <Modal
        title={title}
        footer={renderFooter()}
        processing={isLoading}
        visible={isVisible}
        destroyOnClose={true}
        maskClosable={false}
        onCancel={onCloseModal}
        width={width}
      >
        {children}
      </Modal>
    </div>
  );
};
